import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Umbrella, Truck, Award, Home } from 'lucide-react';
import { useT } from '../utils/i18n';
// Compact trust strip — quiet, earned, not loud. Sits directly under the
// hero so the first thing a skeptical visitor sees after the headline is
// proof we're a real, licensed local operator (something national
// marketplaces structurally cannot match).
export function CredentialsBar() {
  const t = useT();
  const credentials = [{
    icon: ShieldCheck,
    eyebrow: t('credentials.licensed'),
    value: 'WA UBI #604-XXX-XXX'
  }, {
    icon: Umbrella,
    eyebrow: t('credentials.insured'),
    value: '$2M General Liability'
  }, {
    icon: Truck,
    eyebrow: t('credentials.wsdot'),
    value: t('credentials.permitted')
  }, {
    icon: Award,
    eyebrow: t('credentials.bbb'),
    value: t('credentials.rating')
  }, {
    icon: Home,
    eyebrow: t('credentials.family'),
    value: 'Bonney Lake, WA'
  }];
  return <section aria-label="Credentials and certifications" className="w-full bg-stone-100 dark:bg-[#1f1f1f] border-y border-stone-200 dark:border-white/5" data-id="element-525">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8" data-id="element-526">
        {/* Eyebrow */}
        <div className="flex items-center justify-center mb-5 md:mb-6" data-id="element-527">
          <div className="h-px w-8 bg-stone-300 dark:bg-white/15" data-id="element-528" />
          <span className="px-3 text-[10px] font-bold uppercase tracking-[0.18em] text-stone-500 dark:text-white/50" data-id="element-529">
            {t('credentials.eyebrow')}
          </span>
          <div className="h-px w-8 bg-stone-300 dark:bg-white/15" data-id="element-530" />
        </div>

        {/* Credentials row — horizontal scroll on mobile, even grid on md+ */}
        <ul className="flex md:grid md:grid-cols-5 gap-0 overflow-x-auto md:overflow-visible
                     -mx-4 sm:-mx-6 md:mx-0 px-4 sm:px-6 md:px-0
                     snap-x snap-mandatory md:snap-none scrollbar-hide" data-id="element-531">
          {credentials.map((cred, idx) => {
          const Icon = cred.icon;
          return <motion.li key={cred.eyebrow} initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.4,
            delay: idx * 0.06,
            ease: 'easeOut'
          }} className={`shrink-0 md:shrink min-w-[180px] md:min-w-0 snap-start
                            flex items-center gap-3 px-4 md:px-5 py-2
                            ${idx > 0 ? 'md:border-l border-stone-200 dark:border-white/10' : ''}`} data-id="element-532">
                <Icon className="w-5 h-5 text-stone-500 dark:text-white/60 shrink-0" strokeWidth={1.5} data-id="element-533" />
                <div className="min-w-0" data-id="element-534">
                  <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-stone-500 dark:text-white/50 leading-tight" data-id="element-535">
                    {cred.eyebrow}
                  </p>
                  <p className="text-sm font-semibold text-stone-900 dark:text-white truncate leading-snug" data-id="element-536">
                    {cred.value}
                  </p>
                </div>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}